var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2626 12.0375C42.0399 11.1476 41.5863 10.3323 40.9476 9.67389C40.3089 9.01545 39.5078 8.53722 38.6251 8.2875C35.4001 7.5 22.5001 7.5 22.5001 7.5C22.5001 7.5 9.6001 7.5 6.3751 8.3625C5.49243 8.61222 4.6913 9.09045 4.05262 9.74889C3.41394 10.4073 2.96032 11.2226 2.7376 12.1125C2.14737 15.3854 1.85866 18.7056 1.8751 22.0312C1.85406 25.382 2.14278 28.7274 2.7376 32.025C2.98314 32.8872 3.44692 33.6715 4.08412 34.3021C4.72131 34.9328 5.51038 35.3884 6.3751 35.625C9.6001 36.4875 22.5001 36.4875 22.5001 36.4875C22.5001 36.4875 35.4001 36.4875 38.6251 35.625C39.5078 35.3753 40.3089 34.897 40.9476 34.2386C41.5863 33.5802 42.0399 32.7649 42.2626 31.875C42.8483 28.6267 43.137 25.3319 43.1251 22.0312C43.1461 18.6805 42.8574 15.3351 42.2626 12.0375V12.0375Z",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2812 28.1629L29.0625 22.0316L18.2812 15.9004V28.1629Z",
    stroke: "#0073FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f770ecc8823692e125172d7138d42261.svg";
export { ForwardRef as ReactComponent };